import { Dispatch } from "../../config/controller";
import { Usuario } from "../../config/data.types";
import { Model,StateProps } from "../../config/model";

export type { Usuario } from "../../config/data.types";

export interface UsuarioState extends StateProps<Usuario> {
    rowLogado:Usuario
}

export interface UsuarioActions extends Dispatch<Usuario> {
    login:(login:string,senha:string)=>any
    logOff:()=>any
}

const model = new Model<Usuario,UsuarioState>("usuario");

export const initialValueUsuario:Usuario = {
    ...model.getInitialValue(),
    type:"usuario",
    ativo:false,
    login:"",
    nome:"",
    senha:"",
}

export const initialValueUsuarioState:UsuarioState = {
    ...model.getInititalValueState(),
    row:initialValueUsuario,   
    rowLogado:initialValueUsuario
}


